import React, { FunctionComponent } from 'react';
import { useOptimizely } from '../../hooks/useOptimizely';
import { Experiments } from '../../constants/experiments';
import config from '../../config';
import styles from './StartFundraising.module.scss';
interface StartFundraisingProps {
  isGB?: boolean;
}

export const StartFundraising: FunctionComponent<StartFundraisingProps> = ({
  isGB,
}) => {
  const optimizely = useOptimizely();
  const onStartFundraisingClick = () => {
    optimizely &&
      optimizely.track(Experiments.TrackingEvents.startFundraisingClick);
  };
  const onDonateClick = () => {
    optimizely &&
      optimizely.track(Experiments.TrackingEvents.donateToCauseClick);
  };
  return (
    <>
      {/* some comment */}
      <h1 className="jg-sr-only">JustGiving</h1>
      <div
        className={styles.startFdrLanding}
        style={{
          backgroundImage: `url(${config.homepageHeaderBanner})`,
        }}
      >
        <div
          className={`${styles.gradientOverlay} ${styles.relativeContainer}`}
        >
          <div className={`jg-grid-container ${styles.lohSpacingL}`}>
            <section className={`jg-grid-row ${styles.contentContainer}`}>
              <h2 className={styles.startFdrHeader}>
                Do something incredible today
              </h2>
              <p className={styles.startFdrSubHeader}>
                Online fundraising for the people and charities you love
              </p>
            </section>
            <div
              className={`jg-grid-col-s-12 loh-blue-default-link ${styles.ctaContainer}`}
            >
              <a
                href={config.startFundraisingUrl}
                className={`jg-btn--newPrimary loh-blue-default ${styles.startFundButton}`}
                onClick={onStartFundraisingClick}
              >
                Start fundraising
              </a>
              {isGB && (
                <a
                  href={config.oneSearchUrl}
                  className={`jg-btn--newPrimary loh-blue-default ${styles.donateButton}`}
                  onClick={onDonateClick}
                >
                  Donate to a cause
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
